import pre_designed_template2 from "../../../assests/Images/TemplateElement/pre_designed_template2.png";
import { DATE } from "../../../shared/constants.js";
import CardTemplate from "./CardTemplate";

function PreDefineTemplate2({ heading, caption, date, journalId,pageRefresh,ref,menuShow }) {
  return (
    <CardTemplate
      journalId={journalId}
      headingText={heading}
      author={caption}
      date={date || DATE.JOURNAL_FORMAT}
      bgColor="#0ae2cd"
      headingColor="#000000"
      textColor="#ffffff"
      textSize={{ xs: "0.8rem", sm: "1rem", md: "1rem" }}
      widthSize={{ xs: "80%", sm: "70%", md: "70%" }}
      imageTopLeft={pre_designed_template2}
      imageTopLeftStyle={{ width: 70, height: 70, top: 10, left: 10, transform: "rotate(150deg)" }}
      headingMargin={{ xs: "60%", sm: "56%", md: "56%" }}
      pageRefreshCallback={pageRefresh}
      ref={ref}
      menuShow={menuShow}
    />
  );
}

export default PreDefineTemplate2;
